import React, { useCallback, useEffect } from "react";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import {
  dailyTargetsHistoryReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./DailyTargetsHistory.store";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import DailyTargetsHistory from "../../library/DailyTargetsHistory/DailyTargetsHistory";

export const SmartDailyTargetsHistory = (props) => {
  const {
    dailyTargetId,
    onClose,
    searchedParams,
    totalItems,
    history,
    fetchDailyTargetHistory,
    resetState,
  } = props;

  const getData = useCallback(
    (searchParameters) => {
      fetchDailyTargetHistory(dailyTargetId, searchParameters).catch(
        (error) => {
          sendNotification(error, ToastType.ERROR);
        }
      );
    },
    [dailyTargetId, fetchDailyTargetHistory]
  );

  useEffect(() => {
    if (totalItems === 0) {
      getData(searchedParams);
    }
  }, [getData, searchedParams, totalItems]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  return (
    <DailyTargetsHistory
      onClose={onClose}
      getData={getData}
      searchedParams={searchedParams}
      totalitems={totalItems}
      history={history}
    />
  );
};

export default dynamic(
  "dailyTargetsHistoryReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(dailyTargetsHistoryReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartDailyTargetsHistory));
